import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {validationmethod} from '../../shared/common/validationmethod';
import {TrnxCommonTs} from '../../shared/common/trnxCommonTs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {CommonService} from '../../shared/services/common.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {LocalStorageSettingsService} from '../../shared/services/local-storage-settings.service';
import {LoginService} from '../../shared/services/login.service';
import {ReportTemplateButton} from '../../shared/common/ReportTemplateButton';
import {Actionbutton} from '../../shared/common/Actionbutton';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import {AsignUserRoleService} from '../../shared/services/asign-user-role.service';
import { AwssecretpopupComponent } from './awssecretpopup/awssecretpopup.component';
import { EditButton } from 'src/app/shared/common/Editbutton';

/*
   @Author:Abhishek T
   @Date:31-10-2023
   for update or create secrets
*/

@Component({
    selector: 'app-awssecret',
    templateUrl: './awssecret.component.html',
    styleUrls: ['./awssecret.component.scss'],
    standalone: false
})
export class AwssecretComponent implements OnInit {

  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnDefs;

  rowClassRules;

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  pageSize;

  components: any;

  overlayNoRowsTemplate;

  listObjectDropDown: any = [];

  dynamicData = [];

  trnxScreenId;

  ngModelObject = [];

  ngModelObjectDivision = [];

  bootstrapColumn = 0;

  //dropDowns = [];

  retrieveObject: any = [];

  headerNameHtml = '';
3
  buttonName;

  tableName = '';

  tableID = '';

  agGridShow = false;

  retrieveNgModelCreation: any = [];

  screenType;

  value;

  recordsStart = 0;

  screenTypeTOrM = '';

  backgroundColorScreen = '';

  backgroundColorButton = '';

  isdisable: boolean = false;

  buttonIdList: any = [];

  getData: any = [];

  userData:any=[];

  roleData:any=[];
  comapanyId;

  //constructor
  constructor(
    private dialog: MatDialog, private commonService: CommonService, private localStorage: LocalStorageSettingsService,private asignUserRoleService:AsignUserRoleService,
    private snackBar:MatSnackBar,private spinner:NgxUiLoaderService,private linkservice: ReportlinksserviceService,private userRoutingModule: UserRoutingModule,private reportLinkService:ReportlinksserviceService
  ) {
    this.components = {

      buttonRenderer: EditButton,

    };

  }

  async ngOnInit() {
    /* @added by Chandra R
        @date 01-01-2025
        @@desc Below code enable and disable the buttons  in UI based on permission
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorage.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

    


    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };
    
    this.columnDefs = [
      {
        headerName: 'Action',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
         
        },
        pinned: 'left',
        lockPinned: true,
        width: 150,
      },
      {
        headerName: 'Secret Name',
        headerTooltip: 'Secret Name',
        tooltipValueGetter: (params) =>
          'Secret Name : ' + params.value,
        field: 'secretName',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Region',
        headerTooltip: 'Region',
        tooltipValueGetter: (params) =>
          'Region : ' + params.value,
        field: 'region',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'DNS Name',
        headerTooltip: 'DNS Name',
        tooltipValueGetter: (params) =>
          'DNS Name : ' + params.value,
        field: 'Dns',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Environment Name',
        headerTooltip: 'Environment Name',
        tooltipValueGetter: (params) =>
          'Environment Name : ' + params.value,
        field: 'envName',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Values',
        headerTooltip: 'Values',
        tooltipValueGetter: (params) =>
          'Values : ' + params.value,
        field: 'values',
        filter: 'agTextColumnFilter',
        width: 520,
      },

     


    ];
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");

    this.backgroundColorButton = this.localStorage.getSettings("ColorA");

  }

  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridAPI.paginationGetTotalPages();

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

  

    this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }

  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    this.gridAPI = params.api;
    this.getData = [];
    this.gridColumnAPI = params.columnApi;

    this.retrieveAssignUsersRoleByDnsId();
    this.retrieveLogedInUser();



  }
  customArray=[];

  //retrieve Assign Users Role By DnsId
  retrieveAssignUsersRoleByDnsId(){
    this.customArray=[];
    var dnsId = localStorage.getItem('dnsName');
    this.commonService.retrieveSecret().subscribe(response=>
      {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        }
        else {
         
          for (const item of response) {
            const valuesString = Object.entries(item.values)
            //modified password field to remove the empty string
                .map(([key, value]) => `${key}="${value}"`)
                .join(', ');
        
           this. customArray.push({
            dnsid:item.dnsId,
                secretName: item.secretName,
                Dns: item.Dns,
                region: item.region,
                envName:item.envName,
                values: valuesString
            });
        }
        
    
          console.log(this.customArray);
        

          this.spinner.stop();
         
          console.log(response);
          console.log(response.data);
          this.gridAPI.setGridOption('rowData', this.customArray);

        }
      }
    );
  }
  retrieveLogedInUser(){
    this.customArray=[];
    var userId = localStorage.getItem('UserId');
    this.commonService.retrieveLogInUser(parseInt (userId)).subscribe(response=>
      {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        }
        else {
          this.comapanyId=response[0].companyid;
          if(this.comapanyId!=1){
           this. isdisable=true;
          }
        
          console.log(response);
    
          console.log(this.comapanyId);
        


        }
      }
    );
  }

  

  editIcon(e) {
    
    

    let rowData = e.rowData;

    console.log(e.rowData);
    console.log(e.rowData);
     let arr=[]
    if(e.rowData.values!==""){
    arr = e.rowData.values.split(', ')
    .map(item => {
      const [key, value] = item.split('=');
      return { key: key.trim(), value: value.replace(/"/g, '') };
    });}

    console.log(arr);


    var obj = {
      "dnsId":e.rowData.dnsid,
      "region":e.rowData.region,
      "values":arr,
      "secretName":e.rowData.secretName,
      "envName":e.rowData.envName
     
    }
    console.log(obj);
    let dialogRef = this.dialog.open(AwssecretpopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '60%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result=>{
      this.retrieveAssignUsersRoleByDnsId();
    })

  }


/*
  Author-Abhishek T
  31-10-2023
  for oprnning the add record pop-up
*/
  openSaveForm(buttonName) {
 console.log(this.comapanyId);
    if(this.comapanyId!==1){
      this.snackBar.open("You don't have access to perform this action", "OK", {duration: 5000});
      return;
    }
    console.log(this.listObjectDropDown);
    this.buttonName = buttonName;

    let width = '80%';

    if (this.bootstrapColumn == 1) {

      width = '55%';

    }
    var obj={}
    let dialogRef = this.dialog.open(AwssecretpopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '60%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      this.retrieveAssignUsersRoleByDnsId();


    });
  }

  encrypt(text: string, key: string): string {
    let encryptedText = '';
    const keyLength = key.length;
    for (let i = 0; i < text.length; i++) {
      const charCode = text.charCodeAt(i);
      const keyCharCode = key.charCodeAt(i % keyLength);
      const encryptedCharCode = charCode + keyCharCode;
      encryptedText += String.fromCharCode(encryptedCharCode);
    }
    return encryptedText;
  }

  

}

